import React, { Component } from 'react';
import { Container, Tooltip } from 'reactstrap';
import Slider from "react-slick";

import PartnersPageTalkAboutUs from "../../components/portfolio/PartnersPage/PartnersPageTalkAboutUs";
import { injectIntl } from "react-intl";
import ContentLoader from "../../components/ContentLoader";
import Picture from '../../components/Picture'
import MetaTags from '../../components/SEO/MetaTags'
import { handleRequestError, Request } from '../../helpers/request'
import { getVariable } from '../../helpers/variable'
import LocaleLink from '../../components/Routes/LocaleLink'

const tooltipStyle = (style = 'right') => {
    if (style === 'sign'){
        return {
            fontFamily: 'Bayshore',
            position: 'absolute',
            fontSize: '3.4rem',
            right: '3.2rem',
            bottom: '13.6px',
            color: '#ffb219',
            transform: 'rotateZ(-10deg)',
        }
    }

    const tooltip = {
        backgroundColor: '#03011c',
        fontSize: '1.8rem',
        border: '1pt solid #7A6F92',
        padding: '1.35rem 1.5rem 6rem',
        fontFamily: "toska-thin-italic",
        maxWidth: '250px',
        boxShadow: '3px 3px 8px #544b6d',
        textAlign: 'left',
        color: 'white'
    };

    return { ...tooltip }
};

class SpiritPage extends Component
{
    state = {
        variables: null,
        step_open1: false,
        step_open2: false,
        step_open3: false,
        step_open4: false,
    };

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        Request.get('variables/by-category/spirit')
            .then((data) => {
                this.setState({ variables: data })
            })
            .catch(handleRequestError);
    }

    displaySteps = (id, color = 'warning') => (
        <li className={`step${id} step`} onMouseEnter={() => this.setState({ [`step_open${id}`]: true })} onMouseLeave={() => this.setState({ [`step_open${id}`]: false })}>
            <button className={`btn-steps btn-steps-${color}`} id={`step${id}`}>
                {getVariable(this.state.variables, `spirit.advantages.${id}.label`)}
            </button>
            <Tooltip style={tooltipStyle((id === 2 || id === 3) && 'left')} placement="bottom" target={`step${id}`} hideArrow={true} isOpen={this.state[`step_open${id}`]} container={document.getElementById('step' + id)}>
                " {getVariable(this.state.variables, `spirit.advantages.${id}.testimony_content`)} "
                <span style={tooltipStyle('sign')}>
                    {getVariable(this.state.variables, `spirit.advantages.${id}.testimony_author`)}
                </span>
            </Tooltip>
        </li>
    );

    displaySlides = (id) => (
        <div className="slide-items">
            <strong>
                {getVariable(this.state.variables, `spirit.slider_stats.${id}.value`)}
            </strong>
            <h4>
                {getVariable(this.state.variables, `spirit.slider_stats.${id}.text`)}
            </h4>
        </div>
    );

    renderContent = () => {
        if (!this.state.variables) return <ContentLoader/>;

        const settings = {
            dots: true,
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 3000,
        };

        return (
            <>
                <section className="sec-expert">
                    <Container>
                        <div className="expert-head">
                            <h1 className="line-heading">
                                { getVariable(this.state.variables, 'spirit.title') }
                            </h1>
                            <p>
                                { getVariable(this.state.variables, 'spirit.subtitle') }
                            </p>
                        </div>
                        <div className="expert-wrap">
                            <div className="experts">
                                <Slider className="expert-slider" {...settings}>
                                    {this.displaySlides(1)}
                                    {this.displaySlides(2)}
                                    {this.displaySlides(3)}
                                    {this.displaySlides(4)}
                                    {this.displaySlides(5)}
                                </Slider>
                            </div>
                            <div className="advantages">
                                <svg className="pacman" viewBox="0 0 100 100">
                                    <circle cx="50%" cy="50%" r="25%"/>
                                </svg>
                                <ul className="feature-list">
                                    {this.displaySteps(1)}
                                    {this.displaySteps(2, 'primary')}
                                    {this.displaySteps(3, 'danger')}
                                    {this.displaySteps(4)}
                                </ul>
                            </div>
                        </div>
                    </Container>
                </section>

                <section className="sec-specialist">
                    <div className="container specialist-wrapper">
                        <div className="special-team-wrap">
                            <div className="team-special">
                                <h2>
                                    { getVariable(this.state.variables, 'spirit.team.title') }
                                </h2>
                                <p>
                                    { getVariable(this.state.variables, 'spirit.team.subtitle') }
                                </p>
                                <div className="specialist-img">
                                    <Picture
                                        src={require("../../../images/team-spirit.png")}
                                        webp={require("../../../images/team-spirit.webp")} />
                                </div>

                                <LocaleLink to="/team" className="btn btn-line-primary">
                                    { getVariable(this.state.variables, 'spirit.team.button') }
                                </LocaleLink>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-meetup">
                    <div className="container">
                        <div className="meetup-wrap">
                            <div className="meetup-block">
                                <strong>
                                    { getVariable(this.state.variables, 'spirit.stats.1.value') }
                                </strong>
                                <h3>
                                    <div dangerouslySetInnerHTML={{__html: getVariable(this.state.variables, 'spirit.stats.1.text') }}></div>
                                </h3>
                            </div>
                            <div className="meetup-block">
                                <strong>
                                    { getVariable(this.state.variables, 'spirit.stats.2.value') }
                                </strong>
                                <h3>
                                    <div dangerouslySetInnerHTML={{__html: getVariable(this.state.variables, 'spirit.stats.2.text') }}></div>
                                </h3>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    };

    render() {
        const { intl } = this.props;

        return (
            <div className="spirit-page">

                <MetaTags page="spirit" />

                { this.renderContent() }

                <PartnersPageTalkAboutUs
                    from={'spirit'}
                    direction={'left'}
                    left_link={'/jobs'}
                    left_title={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.jobs.label",
                            defaultMessage: "Nos offres d'emploi"
                        })
                    }
                    left_subtitle={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.jobs.content",
                            defaultMessage: "Vous êtes à la recherche du job de vos rêves ? Il se trouve sûrement dans nos dernières annonces."
                        })
                    }
                    right_link={'/recruter-talent'}
                    right_title={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.recruit.label",
                            defaultMessage: "Vous recrutez ?"
                        })
                    }
                    right_subtitle={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.recruit.content",
                            defaultMessage: "Vous êtes à la recherche du candidat ideal ? Laissez nous construire votre dream team."
                        })
                    }
                />

            </div>
        )
    }
}

export default injectIntl(SpiritPage);
